import { FC } from "react";
import { VendingTableDataType } from "./Types";
import moment from "moment";
import { Body } from "../../UIKits/Typography/Typography";
import StatusIndicator from "../../StatusIndicator/StatusIndicator";
import { formatCurrency } from "../../../helper/helper";

interface MobileVendingCardProps {
  data: VendingTableDataType;
  onClick: () => void;
}

export const MobileVendingCard: FC<MobileVendingCardProps> = ({ data, onClick }) => {
  return (
    <div className="my-5 hover:shadow-md cursor-pointer transition-all" onClick={onClick}>
      {/* Date Header */}
      <Body color="secondary" className="mb-2">
        {moment(data.transactionDate).format("DD MMMM, YYYY")}
      </Body>

      <div className="flex  items-center  justify-between">
        <div>
          {/* Token Number with Copy */}
          <div className="mb-1">
            <div onClick={(e) => e.stopPropagation()} className=" ">
              {/* <CopyTextToClipboard textToCopy={data.tokenNumber} /> */}
            </div>
          </div>
          {/* Customer Info */}
          <div className="">
            <Body variant="caption" color="muted-secondary">
              {data.customerName}
            </Body>
            <Body variant="caption" color="muted-secondary" className="mt-1">
              {moment(data.transactionDate).format("h:mm A")} • {data.units}
              
            </Body>
          </div>
        </div>

        {/* Amount and Status */}
        <div className=" ">
          <Body className="text-base text-right mb-1 " color="primary">
            {formatCurrency(data.amount)}
          </Body>
         <StatusIndicator incomingStatus={data.paymentStatusValue} />
        </div>
      </div>
    </div>
  );
};
